import { IApplicationState } from '../../types/redux';

export const selectLocationId = (state: IApplicationState): number | undefined => {
  return state.projectData.location?.id;
};
